import { AxiosInstance } from "axios";

export interface CreateFeedbackRequest {
  boardId: string | null;
  type: string;
  rating: number;
  description: string;
}

export interface FeatureVoteRequest {
  /** Display name of the source or feature being voted for, e.g. "Aha!". */
  feature: string;
  boardId: string | null;
}

/**
 * Feedback API endpoints
 * Platform-agnostic - works with any HTTP client
 */
export class FeedbackApi {
  constructor(private client: AxiosInstance) {}

  /**
   * Submit user feedback (rating + comment), optionally scoped to a board.
   */
  async createFeedback(request: CreateFeedbackRequest): Promise<void> {
    await this.client.post("/api/feedback", request);
  }

  /**
   * Cast a vote for a source or feature that is not available yet. The region
   * records it and posts it to the Teams feedback channel.
   */
  async featureVote(request: FeatureVoteRequest): Promise<void> {
    await this.client.post("/api/feedback/featurevote", request);
  }
}
